import {createRoot} from 'react-dom/client'
// Axios
// import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'

// Apps
// import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
import './_metronic/assets/sass/style.react.scss'
import './_metronic/assets/fonticon/fonticon.css'
import './_metronic/assets/keenicons/duotone/style.css'
import './_metronic/assets/keenicons/outline/style.css'
import './_metronic/assets/keenicons/solid/style.css'

/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import './app/assets/custom_styles/custom_app_style.scss';
import "react-datepicker/dist/react-datepicker.css";

import {AppRoutes} from './app/routing/AppRoutes'
import { AppLoadingProvider } from './app/context/AppLoadingContext'
import AppLoading from './app/custom_components/AppLoading'
import { ModalProvider } from './app/context/ModalContext'
import { MasterDataProvider } from './app/context/MasterDataContext'
import { BackofficeNotificationProvider } from './app/context/BackofficeNotificationContext'
import { VaultSessionProvider } from './app/context/VaultSessionContext'

// import {AuthProvider, setupAxios} from './app/modules/auth'
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
// setupAxios(axios)
Chart.register(...registerables)

const queryClient = new QueryClient()
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      {/* <MetronicI18nProvider> */}
        <AppLoadingProvider>
          <MasterDataProvider>
            <ModalProvider >
              <BackofficeNotificationProvider>
                <VaultSessionProvider>
                  <AppLoading />
                  <AppRoutes />
                </VaultSessionProvider>
              </BackofficeNotificationProvider>
            </ModalProvider>
          </MasterDataProvider>
        </AppLoadingProvider>
      {/* </MetronicI18nProvider> */}
    </QueryClientProvider>
  )
}
